import { ViewRedirectContext } from '@salescore/client-feature-view'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { type ReactElement, useMemo } from 'react'
import { z } from 'zod'

import { ViewLayout } from '../../../../layouts/ViewLayout.tsx'

const Page = (): ReactElement => {
  const { organizationId } = Route.useParams()
  const navigate = useNavigate()
  const value = useMemo(
    () => ({
      // eslint-disable-next-line sonarjs/todo-tag
      // TODO: Contextを使うやり方が適切とは思わないがパッケージ構成上仕方がない
      // パッケージ構成を見直したほうが良いと思う
      redirectToMe: (): void => {
        void navigate({
          to: '/o/$organizationId/v2/settings/me',
          params: { organizationId },
        })
      },
      redirectToEltModelForm: (modelName: string): void => {
        void navigate({
          to: '/o/$organizationId/v2/settings/elt_models/$modelName/form',
          params: { organizationId, modelName },
        })
      },
      redirectToGoalConfig: (goalConfigId: string): void => {
        void navigate({
          to: '/o/$organizationId/v2/settings/goal_configs/$goalConfigId',
          params: { organizationId, goalConfigId },
        })
      },
      redirectToGoalConfigs: (dashboardViewId: string): void => {
        void navigate({
          to: '/o/$organizationId/v2/settings/goal_configs',
          params: { organizationId },
          search: { dashboardViewId },
        })
      },
    }),
    [navigate, organizationId],
  )

  return (
    <ViewRedirectContext.Provider value={value}>
      <ViewLayout />
    </ViewRedirectContext.Provider>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/')({
  validateSearch: (search) =>
    z
      .object({
        viewId: z.coerce.string().optional(), //  数値のみのviewIdが存在し、Tanstack Routerがnumberにキャストしてしまうため
        shareId: z.string().optional(), // 全部UUIDのはずなのでcoerceは不要
      })
      .parse(search),
  component: Page,
})
